import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './theme.css';
import './polish.css';
import { TRICOLOR_THEME_ENABLED } from './themeConfig';

if (TRICOLOR_THEME_ENABLED) {
  document.documentElement.setAttribute('data-theme', 'tricolor');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
